import React from 'react'
import { ColorValue, TouchableOpacity } from 'react-native'
import { StyleService, useStyleSheet } from '@style/service'
import { Text } from '@components/base'

interface ConversationFilterPillProps {
  label: string
  isActive: boolean
  onPress: () => void
  activeBackgroundColor?: ColorValue
  inactiveBackgroundColor?: ColorValue
  activeTextColor?: ColorValue
  inactiveTextColor?: ColorValue
}

export const ConversationFilterPill = ({
  label,
  isActive,
  onPress,
  activeBackgroundColor,
  inactiveBackgroundColor,
  activeTextColor,
  inactiveTextColor,
}: ConversationFilterPillProps) => {
  const styles = useStyleSheet(themedStyle)
  const textColor = isActive ? activeTextColor : inactiveTextColor
  const defaultActiveStyle = isActive ? styles.activeText : undefined
  const textStyle = textColor ? { color: textColor } : defaultActiveStyle

  return (
    <TouchableOpacity
      accessibilityLabel={label}
      onPress={onPress}
      style={[
        styles.pill,
        { backgroundColor: isActive ? activeBackgroundColor : inactiveBackgroundColor },
      ]}
    >
      <Text type="small" bold style={textStyle}>
        {label}
      </Text>
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  pill: {
    borderRadius: 32,
    paddingHorizontal: 16,
    paddingVertical: 4,
  },
  activeText: {
    color: 'theme.background',
  },
})
